/**
 * @generated SignedSource<<da5da917c72d4db698b0dc23bd6d5179>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedContainer_item$data = {
  readonly isSold: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedCircles_item" | "PdpRespCondensedListedContent_item" | "PdpRespSimilarItemsGrid_item" | "PdpRespSimilarItemsLanding_item" | "PdpSharedSellerItemsCarousel_item" | "usePdpRecentHistoryTracker_item">;
  readonly " $fragmentType": "PdpRespCondensedContainer_item";
};
export type PdpRespCondensedContainer_item$key = {
  readonly " $data"?: PdpRespCondensedContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedContainer_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpRecentHistoryTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedListedContent_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedCircles_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "414cb2abaeff4322c401da4527438d2c";

export default node;
